import React, {memo} from "react";

export const IconMe = memo(({color}) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <circle cx="24" cy="24" r="20" fill="#6BC069" />
        <circle cx="24" cy="24" r="19" stroke="white" stroke-width="2" />
      </g>
      <path
        d="M22.1023 25.888C22.1023 26.5387 22.0223 27.1253 21.8623 27.648C21.7023 28.1707 21.4623 28.616 21.1423 28.984C20.8276 29.352 20.4329 29.6347 19.9583 29.832C19.4836 30.0293 18.9316 30.128 18.3023 30.128C18.0143 30.128 17.7316 30.1093 17.4543 30.072C17.1769 30.04 16.8863 29.9867 16.5823 29.912C16.5983 29.6987 16.6169 29.4853 16.6383 29.272C16.6596 29.0587 16.6783 28.8453 16.6943 28.632C16.7103 28.5147 16.7556 28.4213 16.8303 28.352C16.9103 28.2773 17.0223 28.24 17.1663 28.24C17.2569 28.24 17.3743 28.2587 17.5183 28.296C17.6676 28.3333 17.8543 28.352 18.0783 28.352C18.3823 28.352 18.6516 28.3093 18.8863 28.224C19.1209 28.1333 19.3156 27.992 19.4703 27.8C19.6303 27.608 19.7503 27.36 19.8303 27.056C19.9103 26.7467 19.9503 26.3733 19.9503 25.936V18.432H22.1023V25.888ZM31.3453 28.224V30H24.5693V18.432H26.7213V28.224H31.3453Z"
        fill={color || "#fff"}
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
});
